<!--
 * @Date: 2023-12-15 11:46:08
 * @Author: jm
 * @LastEditTime: 2024-03-05 14:56:14
 * @LastEditors: jm
 * @FilePath: \miniclub\src\components\GamesMore.vue
 * @Description: 
-->
<template>
  <div class="content">
    <div class="title">
      <p class="leftWenzi">{{ leftText }}</p>
      <a
        :href="`type.html?type=${leftText}`"
        v-if="leftText !== '' && showMore"
        class="t-right"
      >
        <span class="rightWenzi">MORE</span>
      </a>
    </div>
    <slot name="content"> </slot>
  </div>
</template>

<script>
export default {
  name: "GamesMore",
  props: {
    Iconwidth: {
      type: String,
      required: false,
    },
    Iconheight: {
      type: String,
      required: false,
    },
    leftText: { type: String, required: false, default: "" },
    showMore: { type: Boolean, required: false, default: true },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  .title {
    height: 110px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000000;
    font-size: 40px;
    font-weight: bold;
    .leftWenzi {
      font-size: 60px;
      font-weight: 900;
    }
    
  }
}
</style>